import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';
import { Avatar, Popover, Badge } from 'antd';

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

// Local Deps
import lock from '../Auth/lock';
import { isLoggedIn } from '../Auth/utils';
import './TopNav.scss';
import msgs from '../../config/messages';
import {
  messageCenterRoute,
  accountAdminRoute,
  toolingManagementRoute,
  inventoryManagementRoute,
  superAdminHomeRoute,
  contractCenterRoute,
} from '../../config/navigation/routes';
import SubscriptionLevel from '../Subscription/SubscriptionLevel';
import MySubscriptionLevel from '../Subscription/MySubscriptionLevel';

export default class TopNavAvatar extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    auth: PropTypes.shape({
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      permissions: PropTypes.array,
      role: PropTypes.string,
      email: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    orgInfo: PropTypes.object,
    newMessage: PropTypes.bool.isRequired,
    newMessageCount: PropTypes.number.isRequired,

  };

  static defaultProps = {
    orgInfo: null,
  };

  static initialState = {
    isOpen: false,
    visible: false,
    setTimeoutId: null,
  };

  state = TopNavAvatar.initialState;

  hide = () => {
    clearTimeout(this.state.setTimeoutId);

    this.setState({
      visible: false,
    });
  };

  handleHoverChange = visible => {
    if (visible) {
      const setTimeoutId = setTimeout(() => {
        this.setState({ visible });
      }, 500);
      this.setState({ setTimeoutId });
    } else {
      this.setState({ visible: false });
    }
  };

  render() {
    const {
      auth,
      login,
      logout,
      orgInfo,
      newMessage,
      newMessageCount,
      toggle,
    } = this.props;
    const role = auth.role;
    let roleTxt = '';
    if (role === 'COMMON_USER') {
      roleTxt = 'Common User';
    } else if (role === 'COMMON_ADMIN') {
      roleTxt = 'Common Admin'
    } else if (role === 'GOVERNMENT_USER') {
      roleTxt = 'Government User';
    } else if (role === 'SUPER_ADMIN') {
      roleTxt = 'Super Admin';
    }
    const content =
      <div className='popOverUserContent'>
        {orgInfo && orgInfo.name && (<span>{orgInfo.name}<br /></span>)}
        {orgInfo && orgInfo.cageCode && (<span>{orgInfo.cageCode}<br /></span>)}
        {<span>{auth.email}<br /></span>}
        {<span>{roleTxt}</span>}
        <MySubscriptionLevel />
      </div>
    return (


      <UncontrolledDropdown nav inNavbar className="nav-item--last" isOpen={this.state.isOpen} onClick={() => { this.setState((prevState) => ({ isOpen: !prevState.isOpen })) }}>
        <DropdownToggle nav >
          {isLoggedIn(auth) && (
            <Popover
              placement="rightBottom"
              content={content}
              trigger="hover"
              visible={this.state.visible}
              onVisibleChange={this.handleHoverChange}
              overlayClassName="popOverUser"
            >
              {newMessage && (
                <Badge
                  count={newMessageCount}
                  overflowCount={999}
                >
                  <Avatar
                    onMouseLeave={this.hide}
                    onClick={this.hide}
                    // size="large"
                    style={{
                      backgroundColor: '#ff7c52',
                      // fontWeight: 600,
                      fontSize: '20px',
                      verticalAlign: 'middle',
                    }}
                  >
                    {auth.name.charAt(0)}
                  </Avatar>
                </Badge>
              )}
              {!newMessage && (
                <Avatar
                  onMouseLeave={this.hide}
                  onClick={this.hide}
                  style={{
                    backgroundColor: '#ff7c52',
                    // fontWeight: 600,
                    fontSize: '20px',
                    verticalAlign: 'middle',
                  }}
                >
                  {auth.name.charAt(0)}
                </Avatar>
              )}
            </Popover>
          )}
          {!isLoggedIn(auth) && <i className="fa fa-user-circle" />}

        </DropdownToggle>

        <DropdownMenu right>

          <DropdownItem
            onClick={() => {
              if (isLoggedIn(auth)) {
                logout();
              } else {
                lock.show();
                const authPromise = lock.getAuthorizedPromise ? lock.getAuthorizedPromise() : lock.authorizedPromise;
                authPromise.then(jwtToken => {
                  login(jwtToken);
                }).catch(error => {
                  console.error('Login error:', error);
                });
              }
            }}
          >
            {isLoggedIn(auth) ? 'Logout' : 'Login'}
          </DropdownItem>

          {role &&
            auth.permissions &&
            auth.permissions.includes(1) && (
              <LinkContainer
                to={messageCenterRoute}
                isActive={() => false}
                onClick={() => toggle(false)}
              >
                <DropdownItem>Message Center</DropdownItem>
              </LinkContainer>
            )}

          {role &&
            auth.permissions &&
            auth.permissions.includes(1) && (
              <LinkContainer
                to={contractCenterRoute}
                isActive={() => false}
                onClick={() => toggle(false)}
              >
                <DropdownItem>RFQ Management</DropdownItem>
              </LinkContainer>
            )}

          {role &&
            auth.permissions &&
            auth.permissions.includes(2) && (
              <LinkContainer
                to={toolingManagementRoute}
                isActive={() => false}
              >
                <DropdownItem
                  onClick={() => toggle(false)}
                >
                  Tooling Management
                </DropdownItem>
              </LinkContainer>
            )}

          {role &&
            auth.permissions &&
            auth.permissions.includes(3) && (
              <LinkContainer
                to={inventoryManagementRoute}
                isActive={() => false}
              >
                <DropdownItem
                  onClick={() => toggle(false)}
                >
                  Inventory Management
                </DropdownItem>
              </LinkContainer>
            )}

          {role &&
            role.toUpperCase().includes('ADMIN') && (
              <LinkContainer
                to={accountAdminRoute}
                isActive={() => false}
              >
                <DropdownItem
                  onClick={() => toggle(false)}
                >
                  {msgs.TopNav.userDropdown.accountOrginization}
                </DropdownItem>
              </LinkContainer>
            )}

          {role &&
            role.toUpperCase().includes('SUPER_ADMIN') && (
              <LinkContainer
                to={superAdminHomeRoute}
                isActive={() => false}
              >
                <DropdownItem
                  onClick={() => toggle(false)}
                >
                  {msgs.TopNav.userDropdown.superAdminHome}
                </DropdownItem>
              </LinkContainer>
            )}
          <SubscriptionLevel auth={auth} onSelect={() => { this.setState({ isOpen: false }) }} />
        </DropdownMenu>
      </UncontrolledDropdown>


    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopNav/TopNavAvatar.jsx